import React from "react";
import clsx from "clsx";
import Switch from "../../Switch/Switch";
import IncidentalDepositBuilderAuthorizationAmount from "./IncidentalDepositBuilderAuthorizationAmount";
import IncidentalDepositBuilderAuthorizationMaintenance from "./IncidentalDepositBuilderAuthorizationMaintenance";
import IncidentalDepositBuilderErrors from "../IncidentalDepositBuilderErrors";
import RichTextEditor from '../../RichTextEditor/RichTextEditor';

class IncidentalDepositBuilderGeneral extends React.Component {

  constructor(props) {
    super(props)

    this.renderFieldClasses = this.renderFieldClasses.bind(this)
    this.renderFieldErrors = this.renderFieldErrors.bind(this);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true,
    })

    var incidentalDeposit = this.props.incidental_deposit

    return (
      <div className={tabClasses} id="general">
        <div>
          {this.renderErrors()}
          {this.renderIncidentalDeposit(incidentalDeposit)}
        </div>
      </div>
    );
  }

  renderIncidentalDeposit(incidentalDeposit) {
    if (incidentalDeposit && incidentalDeposit.deposit_type == null) {
      incidentalDeposit.deposit_type = 'none';
    }

    return (
      <div>
        <div className="row">
          {this.renderName(incidentalDeposit)}
          {this.renderDepositType(incidentalDeposit)}
          {this.renderIncidentalDepositAuthorization(incidentalDeposit)}
        </div>
        {
          incidentalDeposit.deposit_type == 'store_a_valid_card' || incidentalDeposit.deposit_type == "none" || incidentalDeposit.deposit_type == "no_deposit"
          ?
          null
          :
          <div>
            <br />
            <div className="row">
              {this.renderAmount(incidentalDeposit)}
              {this.renderMaintainAuthorization(incidentalDeposit)}
          </div>
        </div>
        }
      </div>
    )
  }

  renderErrors() {
    var errors = IncidentalDepositBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return(
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, classname) {
    var classname = classname || 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderMaintainAuthorization(incidentalDeposit) {
    return(
      <div className="col-md-6">
        <div className="panel default-panel">
          <div className="panel-body">
            <IncidentalDepositBuilderAuthorizationMaintenance {...this.props} onChange={this.props.onChangeMaintainAuthorization}/>
          </div>
        </div>
      </div>
    )
  }

  renderAmount(incidentalDeposit) {
    return (
      <div className="authorization-amount">
        <div className="form-group">
          <div className={this.renderFieldClasses('authorization_amount', 'panel default-panel')}>
            <div className={`panel-body`}>
              <IncidentalDepositBuilderAuthorizationAmount {...this.props} renderFieldErrors={this.renderFieldErrors} renderFieldClasses={this.renderFieldClasses}  />
            </div>
          </div>
          {this.renderFieldErrors('authorization_amount')}
        </div>
      </div>

    );
  }

  renderName(incidentalDeposit) {
    return(
      <div className="col-md-4">
        <div className="form-group">
          <label>{`${I18n.t('name')}*`}</label>
          <input name="name" type="text" defaultValue={incidentalDeposit.name} className={this.renderFieldClasses('name')} data-model="IncidentalDeposit" data-column="name" onChange={this.props.onChange}/>
          {this.renderFieldErrors('name')}
        </div>
      </div>
    )
  }

  renderIncidentalDepositAuthorization(incidentalDeposit) {
    if(incidentalDeposit.deposit_type != "none" )
    return(
      [
        <div className="col-md-2" key="incidental-validate-befor-arrival">
            <div className="form-group">
              <label>{I18n.t('validate_before_arrival')} <span className="ss-help help" title={I18n.t('pre_auth_helper_text')}></span> </label>
              <Switch 
                onText="yes" 
                switchId="validate-before-arrival-switch" 
                offText="no"
                value={incidentalDeposit.pre_authorization} 
                onChange={this.props.onChangeAuthorize}
              />
            </div>
        </div>,
        <div className="col-md-4" key="incidental-description">
            <div className="form-group">
              <label>{I18n.t('description')}*<span className="ss-help help" title={I18n.t('incidental_deposit_description_helper_text')}></span> </label>
              <RichTextEditor 
                height={150} 
                name="description" 
                body={incidentalDeposit.description ? incidentalDeposit.description : ''} 
                onChange={this.props.onChangeRichText.bind(this, 'description')}
                className={this.renderFieldClasses('description')}
                />
              {this.renderFieldErrors('description')}
            </div>
        </div>
      ]
    );
  };
  

  renderDepositType(incidentalDeposit) {
    return(
      <div className="col-md-2">
        <div className="form-group">
          <label>{I18n.t('deposit_type')} <span className="ss-help help" title={I18n.t('incidental_deposit_type_help_text')}></span></label>
          {
            this.props.read_only
            ?
            <div>{I18n.t(incidentalDeposit.deposit_type)}</div>
            :
            <select defaultValue={incidentalDeposit.deposit_type} onChange={this.props.onChangeDepositType} className="form-control">
              <option value="none">{I18n.t('none')}</option>
              <option value="store_a_valid_card">{I18n.t('store_a_valid_card')}</option>
              <option value="auth_and_hold_amount">{I18n.t('auth_and_hold_amount')}</option>
            </select>
          }
        </div>
      </div>
    )
  }

}

export default IncidentalDepositBuilderGeneral